import { TextField, Tooltip } from "@mui/material";

import { getTodayLocalDateString } from "../../utils";

interface Props {
  label: string;
  tooltip: string;
  value: string;
  onChange: (localDate: string) => void;
}

export function LaneExpiryDateField(props: Props) {
  const { label, tooltip, value, onChange } = props;
  // Always today, even when the field holds an already-lapsed date. The lapsed value
  // still displays, but every day the picker offers is one the API accepts: a past date
  // other than the stored one is rejected as a newly proposed expiry.

  return (
    <Tooltip title={tooltip}>
      <TextField
        fullWidth
        label={label}
        type="date"
        value={value}
        inputProps={{ min: getTodayLocalDateString() }}
        InputLabelProps={{ shrink: true }}
        onChange={(e) => onChange(e.target.value)}
        size="small"
      />
    </Tooltip>
  );
}
